exports.components = {
  "component---src-pages-cenovnik-index-js": () => import("./../../../src/pages/cenovnik/index.js" /* webpackChunkName: "component---src-pages-cenovnik-index-js" */),
  "component---src-pages-demo-index-js": () => import("./../../../src/pages/demo/index.js" /* webpackChunkName: "component---src-pages-demo-index-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

